import styled, { type CSSProp } from 'styled-components';

interface WrapperProps {
    $flexDirection: 'row' | 'column';
    $flexWrap?: CSSProp;
    $justifyContent?: CSSProp;
    $alignItems?: CSSProp;
    $margin?: CSSProp;
    $gap?: CSSProp;
    $padding?: CSSProp;
    $width?: CSSProp;
    $height?: CSSProp;
}
export const FlexWrapper = styled.div<WrapperProps>`
    display: flex;
    flex-direction: ${({ $flexDirection }) => $flexDirection};
    align-items: ${({ $alignItems }) => $alignItems};
    justify-content: ${({ $justifyContent }) => $justifyContent};
    padding: ${({ $padding }) => $padding};
    margin: ${({ $margin }) => $margin};
    gap: ${({ $gap }) => $gap};
    flex-wrap: ${({ $flexWrap }) => $flexWrap};
    width: ${({ $width }) => $width ?? '100%'};
    height: ${({ $height }) => $height ?? 'unset'};
    > {
        display: flex;
    }
`;
